<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4>          
            <v-card pa-0>  
              <v-toolbar dense cad flat>
                <v-toolbar-title class="title">Form Payment</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!isUpdate" @click="save(isUpdate)" :loading="loading" color="success">Create</v-btn>
                <v-btn v-else @click="save(isUpdate)" :loading="loading" color="primary">Save</v-btn>                 
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-lg class="pa-0 ma-0">                  
                  <v-layout row wrap>                     
                    <v-flex lg12 md12 sm12 xs12>
                      <v-select
                        label="reff type"
                        v-model="fm.reff_type"
                        v-bind:items="payments"
                        item-text="name"
                        item-value="id"
                        data-vv-name="reff_type"   
                        v-validate="'required'"
                        :error-messages="errors.collect('reff_type')"                  
                      >                        
                      </v-select>                      
                      <v-autocomplete
                        v-model="fm.calon_id"
                        :items="siswa.items"
                        :loading="siswa.loading"
                        :search-input.sync="siswa.search"
                        chips
                        clearable                      
                        hide-selected
                        item-text="nama"
                        item-value="id"
                        label="Search for Siswa" 
                        :filter="customFilter"                        
                      >
                        <template v-slot:no-data>
                          <v-list-tile>
                            <v-list-tile-title>
                              Search for 
                              <strong>Siswa</strong>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                        <template v-slot:selection="{ item, selected }">
                          <v-chip
                            :selected="selected"
                            color="blue-grey"
                            class="white--text"
                          >
                            <v-icon left>mdi-coin</v-icon>
                            <span v-text="item.nama"></span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-tile-avatar
                            :color="getColor(item.tingkat_id)"
                            class="headline font-weight-light white--text"
                          >
                            {{ item.nama.charAt(0) }}
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{item.nama}} - {{item.reff_bill}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{tingkats.find(x=>x.id === item.tingkat_id).nama}}, TTL : {{item.lahir_tempat}} {{$moment(item.lahir_tanggal).format('DD/MM/YY')}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon>mdi-coin</v-icon>
                          </v-list-tile-action>
                        </template>
                      </v-autocomplete> 
                      <v-text-field 
                        append-icon="monetization_on" 
                        label="nominal" 
                        type="number" 
                        v-model="fm.nominal"                
                        data-vv-name="nominal"   
                        v-validate="'required'"
                        :readonly="true"
                        :error-messages="errors.collect('nominal')"                  
                      ></v-text-field> 
                      <v-text-field 
                        append-icon="account_balance_wallet" 
                        label="reff number" 
                        type="text" 
                        v-model="fm.reff_number"                
                        data-vv-name="reff_number"   
                        v-validate="'required'"
                        :error-messages="errors.collect('reff_number')"                  
                      ></v-text-field> 
                      <v-textarea 
                        label="Keterangan" 
                        type="text" 
                        v-model="fm.description"                                                       
                      ></v-textarea> 
                    </v-flex>                    
                  </v-layout>                    
                </v-container>               
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/admin/models/Calon';    

var model = new Model();

export default {
  components : {},
  $_veeValidate: {
      validator: 'new'
  },    
  data: () => ({
      showpass:false,
      isEditing:true,
      isUpdate:false,                
      cropshow: false,
      loading : false,
      imgUrl : null,
      imgLoading : false,
      saveLoading : false,
      completeLoading : false,    
      fm : {
        calon_id : null,
        reff_type : 1,
        reff_number : null,
        reff_id : null,
        nominal : null,
        description : null,
        status : null,
        calon : {},
      },
      tingkats : [],
      types : [],
      status : [],   
      siswa : {search:null, loading:false, items:[]},
      payments:[],
  }),
 // created () {this.getParents()},    
  mounted () {
    model.tingkats().then(data=>{this.tingkats = data; console.log(data);});
    model.paymentTypes().then(data=>{this.types = data; });
    model.paymentStatus().then(data=>{this.status = data;});
    model.settings({key:'payment_method'}).then(res=>{
      this.payments = res.value;
    });
    this.$watch(['siswa','search'].join('.'), (newSrc)=>{
      setTimeout(()=>{
        this.siswa.loading = true;
        if(newSrc === this.siswa.search){
          model.indexSearch({'UserCalonSearch[nama]':newSrc}).then((data)=>{
            this.siswa.items = data; this.siswa.loading = false;            
          });
        }
      }, 500);
    });
    this.$watch(['fm','calon_id'].join('.'), (newSrc)=>{      
      if(newSrc){
        if(!this.siswa.items.find(x=>x.id === newSrc)){
          this.siswa.loading = true;
          model.indexSearch({'UserCalonSearch[id]':newSrc}).then((data)=>{
            this.siswa.items = data;   
            if(this.siswa.items.find(x=>x.id === newSrc)){
              let data = this.siswa.items.find(x=>x.id === newSrc);
              this.fm.nominal = this.tingkats.find(x=>x.id === data.tingkat_id).biaya;
              if(this.fm.reff_type === 2 || this.fm.reff_type === 1){
                this.fm.reff_number = data.reff_bill; 
              }

              let paym = this.payments.find(x=>x.id==this.fm.reff_type);
              if(paym && this.fm.reff_type>2){
                this.fm.nominal = paym.childs.nominal;
              }
            }
            this.siswa.loading = false;
          });
        } else {
          let data = this.siswa.items.find(x=>x.id === newSrc);
          this.fm.nominal = this.tingkats.find(x=>x.id === data.tingkat_id).biaya;
          if(this.fm.reff_type === 2){
            this.fm.reff_number = data.reff_bill; 
          }
        }
        
        let paym = this.payments.find(x=>x.id==this.fm.reff_type);
        if(paym && this.fm.reff_type>2){
          this.fm.nominal = paym.childs.nominal;
        } 
      } else {
        this.fm.nominal = null;        
      }       
    });
    this.$watch(['fm','reff_type'].join('.'), (newType)=>{
      if(newType === 2 || newType === 1){
        if(this.fm.calon_id && this.siswa.items.find(x=>x.id === this.fm.calon_id)){
          let data = this.siswa.items.find(x=>x.id === this.fm.calon_id);
          this.fm.reff_number = data.reff_bill;
          this.fm.nominal = this.tingkats.find(x=>x.id === data.tingkat_id).biaya;
        }
      } else {
        let paym = this.payments.find(x=>x.id==newType);
        if(paym && this.fm.reff_type>2){
          this.fm.nominal = paym.childs.nominal;
        }        
      }
    });
    this.init();
  }, 
  methods : {
    init(){
      if(this.$route.query.id){
        //this.fm.user_id = this.user.id; this.fm.telepon = this.user.phone;      
        this.isUpdate   = true;
        model.onePayment({id : this.$route.query.id }).then(data => {                     
          Object.assign(this.fm, data === null ? {}:data);          
        });                                               
      }               
      
      if(this.$route.query.calon_id){
        this.fm.calon_id = null;
        setTimeout(()=>{this.fm.calon_id = this.$route.query.calon_id;}, 1000);        
      }
    },
    
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
    },

    save(isUpdate = false) {                
      this.$validator.validateAll();
      this.loading = true;
      if( !this.errors.any() ) {
        model.savePayment(this.fm).then((res)=>{
          if(res.status === 200){
            this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
            this.$router.push({path:'/signup/calon/payment/view', query:{id:res.data.id}});                    
          }else {            
            if(res.data){ if(res.data.message){} else {this.validate(res.data);}}                            
          }
          this.loading = false;
        });                  
      }             
    },
       
    validate(data){
        data.forEach( (item) => {
            this.$validator.errors.add({field : item.field,msg : item.message});
        });
    },           

    customFilter (item, queryText, itemText) {
        const textOne = item.nama.toLowerCase();
        const textTwo = item.reff_bill.toLowerCase();
        const searchText = queryText.toLowerCase();        
        return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1; 
    },    
      
    
  }
}
</script>